import authRequest from '../authRequest';
import SubscriptionPresenter from '../../presenters/SubscriptionPresenter';

const getCurrentSubscription = async () => {
  try {
    const response = await authRequest('/billing/current_subscription', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (response.status !== 200) {
      throw new Error('Error fetching current subscription');
    }
    
    // Create and return a SubscriptionPresenter instance with the raw subscription data
    return new SubscriptionPresenter(response.data);
  } catch (error) {
    console.error('Error fetching current subscription:', error);
    throw error;
  }
};

export default getCurrentSubscription; 